import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useSystemApplicationReducer = () =>
  useSelector((state: ApplicationState) => state.systemApplication);
